export default __webpack_public_path__ + "svg/CompaniesLogos/logo_numericco.svg?53419145";